import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import DirectoryPage from "@/pages/directory/page";
import CategoriesPage from "@/pages/categories/page";
import CategoryIndexPage from "@/pages/category-index/page";
import FeaturedListingsPage from "@/pages/featured-listings/page";
import CategoryPage from "@/pages/category/page";
import LocationsPage from "@/pages/locations/page";
import LocationPage from "@/pages/location/page";
import BusinessPage from "@/pages/business/page";
import SpotPage from "@/pages/spot/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import TouristSpotsPage from "@/pages/tourist-spots/page";
import WhyUsPage from "@/pages/why-us/page";
import FaqsPage from "@/pages/faqs/page";
import TermsPage from "@/pages/terms/page";
import PlansPage from "@/pages/plans/page";
import ListBusinessPage from "@/pages/list-business/page";
import EmergencyServicesPage from "@/pages/emergency/page";
import PortalLoginPage    from "@/pages/portal/login/page";
import PortalRegisterPage from "@/pages/portal/register/page";
import PortalDashboardPage from "@/pages/portal/dashboard/page";
import PortalListingsPage  from "@/pages/portal/listings/page";
import PortalOrdersPage    from "@/pages/portal/orders/page";
import PortalReviewsPage   from "@/pages/portal/reviews/page";
import PortalProfilePage  from "@/pages/portal/profile/page";
import PortalMediaPage    from "@/pages/portal/media/page";
import AdminPanelPage     from "@/pages/portal/admin/page";

const routes: RouteObject[] = [
  // ── Public directory routes ─────────────────────────────────────────────────
  { path: "/",                    element: <Home /> },
  { path: "/directory",           element: <DirectoryPage /> },
  { path: "/categories",          element: <CategoriesPage /> },
  { path: "/categories-a-z",      element: <CategoryIndexPage /> },
  { path: "/featured-listings",   element: <FeaturedListingsPage /> },
  { path: "/category/:slug",      element: <CategoryPage /> },
  { path: "/locations",           element: <LocationsPage /> },
  { path: "/location/:slug",      element: <LocationPage /> },
  { path: "/tourist-spots",       element: <TouristSpotsPage /> },
  { path: "/why-us",              element: <WhyUsPage /> },
  { path: "/faqs",                element: <FaqsPage /> },
  { path: "/terms-and-conditions", element: <TermsPage /> },
  { path: "/business/:slug",      element: <BusinessPage /> },
  { path: "/spot/:slug",          element: <SpotPage /> },
  { path: "/listing-plans",       element: <PlansPage /> },
  { path: "/emergency-services",  element: <EmergencyServicesPage /> },
  { path: "/list-your-business",  element: <ListBusinessPage /> },
  { path: "/about",               element: <AboutPage /> },
  { path: "/contact",             element: <ContactPage /> },

  // ── Owner Portal ────────────────────────────────────────────────────────────
  { path: "/login",    element: <PortalLoginPage /> },
  { path: "/register", element: <PortalRegisterPage /> },
  { path: "/account",  element: <PortalDashboardPage /> },
  { path: "/listings", element: <PortalListingsPage /> },
  { path: "/orders",   element: <PortalOrdersPage /> },
  { path: "/reviews",  element: <PortalReviewsPage /> },
  { path: "/media",    element: <PortalMediaPage /> },
  { path: "/profile",  element: <PortalProfilePage /> },
  { path: "/admin",    element: <AdminPanelPage /> },

  // ── 404 ─────────────────────────────────────────────────────────────────────
  { path: "*", element: <NotFound /> },
];

export default routes;